import { useTranslation } from '../../i18n/LanguageContext'
import Modal from '../Modal/Modal'
import './AboutModal.css'

const AboutModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation()
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`⚔️ ${t('about.title')}`}>
      <div className="about">
        <section className="about__section">
          <h3 className="about__subtitle">
            <img src="/assets/logo-128x128.svg" alt="Unity-BOT" className="about__bot-icon" />
            {t('about.botName')}
          </h3>
          <p className="about__text">{t('about.botDesc', { name: 'Unity-BOT' })}</p>
          
          <h4 className="about__feature-title">🎯 {t('about.coreFeatures')}</h4>
          <ul className="about__list">
            <li><strong>{t('about.smartHunt')}</strong> - {t('about.smartHuntDesc')}</li>
            <li><strong>{t('about.smartHeal')}</strong> - {t('about.smartHealDesc')}</li>
            <li><strong>{t('about.questAuto')}</strong> - {t('about.questAutoDesc')}</li>
            <li><strong>{t('about.skillTrain')}</strong> - {t('about.skillTrainDesc')}</li>
          </ul>

          <h4 className="about__feature-title">⚙️ {t('about.advancedCaps')}</h4>
          <ul className="about__list">
            <li><strong>{t('about.actionScript')}</strong> - {t('about.actionScriptDesc')}</li>
            <li><strong>{t('about.autoChecker')}</strong> - {t('about.autoCheckerDesc')}</li>
            <li><strong>{t('about.antiDetect')}</strong> - {t('about.antiDetectDesc')}</li>
            <li><strong>{t('about.resourceOpt')}</strong> - {t('about.resourceOptDesc')}</li>
          </ul>

          <h4 className="about__feature-title">🛡️ {t('about.safetyTitle')}</h4>
          <ul className="about__list">
            <li>✅ {t('about.safety1')}</li>
            <li>✅ {t('about.safety2')}</li>
            <li>✅ {t('about.safety3')}</li>
            <li>✅ {t('about.safety4')}</li>
            <li>✅ {t('about.safety5')}</li>
          </ul>

          <h4 className="about__feature-title">👥 {t('about.communityTitle2')}</h4>
          <p className="about__text">{t('about.communityDesc')}</p>
        </section>

        <div className="about__divider">⚜️</div>

        <section className="about__section">
          <h3 className="about__subtitle">
            <img src="/assets/tibiame_logo.png" alt="TibiaME" className="about__game-icon" />
            {t('about.tibiameTitle')}
          </h3>
          <p className="about__text">{t('about.tibiameDesc1', { name: 'TibiaME', classic: 'Tibia' })}</p>
          <p className="about__text">{t('about.tibiameDesc2')}</p>
          <p className="about__text about__highlight">
            📱 {t('about.tibiameAvailable')}
          </p>
        </section>

        <div className="about__divider">⚜️</div>

        <section className="about__section">
          <h3 className="about__subtitle">
            <img src="/assets/Logo_CipSoft.png" alt="CipSoft" className="about__company-icon" />
            {t('about.cipsoftTitle')}
          </h3>
          <p className="about__text">{t('about.cipsoftDesc', { name: 'CipSoft', classic: 'Tibia' })}</p>
          <ul className="about__list">
            <li>🎮 {t('about.cipsoftTibia', { game: 'Tibia' })}</li>
            <li>📱 {t('about.cipsoftTibiame', { game: 'TibiaME' })}</li>
            <li>🏰 {t('about.cipsoftSettlers', { game: 'The Settlers Online' })}</li>
            <li>🧟 {t('about.cipsoftPersist', { game: 'Persist Online' })}</li>
          </ul>
          <p className="about__text about__award">
            🏆 {t('about.cipsoftAward')}
          </p>
        </section>

        <div className="about__divider">⚜️</div>

        <section className="about__section about__disclaimer">
          <h3 className="about__subtitle">⚠️ {t('about.legalNotice')}</h3>
          <p className="about__text">{t('about.legalDesc1', { name: 'Unity-BOT' })}</p>
          <p className="about__text">{t('about.legalDesc2')}</p>
        </section>

        <div className="about__version">
          <span>{t('about.version')}</span>
          <span>{t('about.copyright')}</span>
        </div>
      </div>
    </Modal>
  )
}

export default AboutModal
